<template>
  <CRow>
    <CCol col="12" md="12">
      <CCard style="top: 10px">
        <CCardHeader>
          <p>
            Prediction List
            <CButton
              block
              color="success"
              style="float: right; width: 120px"
              @click="wizard()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
            >
          </p>
        </CCardHeader>

        <CCardBody>
          <CDataTable
            :items="tableData"
            :fields="fields"
            pagination
            clickable-rows
            hover
          >
            <template #image="{ item }">
              <td>
                <img :src="item.image" style="width: 50px; height: 50px" />
              </td>
            </template>
            <template #status="{ item }">
              <td>
                <span v-if="item.status == true">
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-success ml-1"
                  >
                    Active
                  </a></span
                >
                <span v-else>
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-danger ml-1"
                  >
                    InActive
                  </a>
                </span>
              </td>
            </template>
            <template #QuizStatus="{ item }">
              <td v-if="item.endtime.seconds < todaydate.seconds">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-warning ml-1"
                >
                  completed
                </a>
              </td>

              <td v-else>
                <span>
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-primary ml-1"
                  >
                    Live
                  </a>
                </span>
              </td>
            </template>
            <template #Action="{ item, index }">
              <td>
                <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  style="width: 54px"
                  @click="editToken(item, index)"
                >
                  Edit </CButton
                ><br /><br />
                <!-- <CButton
                  color="danger"
                  variant="outline"
                  square
                  size="sm"
                  @click="deleteRoute(item, index)"
                >
                  Delete
                </CButton> -->
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../tables/Table";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import { secondaryDatabase } from "./secondary.js";
import moment from "moment";

export default {
  components: { CTableWrapper },
  data() {
    return {
      fields: [
        {
          label: "Image",
          key: "image",
          sortable: true,
        },
        {
          label: "Date",
          key: "Date",
          sortable: true,
        },
        {
          label: "StartDate",
          key: "StartDate",
          sortable: true,
        },
        {
          label: "Quiz Status",
          key: "QuizStatus",
          sortable: true,
        },
        {
          label: "Status",
          key: "status",
          sortable: true,
        },

        // {
        //    label: "field4",
        //   key: "field4",
        //   sortable: true,
        // },
        {
          key: "Action",
          sortable: true,
        },
      ],
      speciesCode: null,
      speciesName: "",
      documentId: "",
      tableData: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      image1: false,
    };
  },
  methods: {
    wizard() {
      this.$router.push({ name: "addPrediction" });
    },
    editToken(item, index) {
      this.$router.push({
        name: "editPrediction",
        params: { id: item.id, data: "DFS" },
      });
    },
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        quizTitle: doc.data().quizTitle,
        question: doc.data().question,
        options: doc.data().options,
        answer: doc.data().answer,
        status: doc.data().status,
        image: doc.data().image,
        quiztype: doc.data().quiztype,
        starttime: doc.data().starttime,
        endtime: doc.data().endtime,
        scramble: doc.data().scramble,
        dfs: doc.data().dfs,
        Date: moment(doc.data().quizdate.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        StartDate: moment(doc.data().starttime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        EndDate: moment(doc.data().endtime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
      };
      return smallDocument;
    },
    getquiz() {
      this.tableData = [];
      // let dbs = secondaryDB.secondaryDatabase;
      secondaryDatabase
        .collection("quizprediction")
        .where("dfs", "==", true)
        .orderBy("quizdate", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));
          });

          this.loading = false;
        });
    },
    rowClicked(item, index, column, e) {
      this.documentId = item.id;
    },

    deleteRoute(item) {
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("companyDetails2")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.getquiz();
    this.todaydate = firebase.firestore.Timestamp.fromDate(new Date());
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
</style>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>
